import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  nacionalidades:[],
};
export const mutations = {
  FILL_NACIONALIDADES({ context }, nacionalidades) {
    let lista_nacionalidades = [];
    if (nacionalidades) {
      Object.entries(nacionalidades).forEach(([key, val]) => lista_nacionalidades.push(val));
      return (state.nacionalidades = lista_nacionalidades);
    }
  }
};
export const actions = {
    GET_NACIONALIDADES({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
              commit("SET_LOADING", false);
              commit("FILL_NACIONALIDADES", response.data.data.nacionalidades);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
};

export const getters = {
  listNacionalidades: state => state.nacionalidades,
};
